import { render } from "./ContactUs.vue?vue&type=template&id=6298a6b2&scoped=true"
import script from "./ContactUs.vue?vue&type=script&lang=js"
export * from "./ContactUs.vue?vue&type=script&lang=js"

import "@/assets/css/mypage.css?vue&type=style&index=0&id=6298a6b2&scoped=true&lang=css&external"
import "./ContactUs.vue?vue&type=style&index=1&id=6298a6b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6298a6b2"]])

export default __exports__